import { render, staticRenderFns } from "./BroadcastCall.vue?vue&type=template&id=4f83d594&"
import script from "./BroadcastCall.vue?vue&type=script&lang=js&"
export * from "./BroadcastCall.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastCall.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports